import Vue from 'vue';
import exchangeForeignInterests from './exchange-foreign-interests/exchange-foreign-interests.vue';
import store from '../common/js/vuex/store';
import exchangeRateStore from '../applications/exchange-rate/exchange-rate-vuex';
if (!store.hasModule(['exchangeRate'])) {
	store.registerModule('exchangeRate', exchangeRateStore);
}

Vue.component('exchange-foreign-interests', exchangeForeignInterests);
